import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { supabase } from '../../lib/supabase';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AuthModal: React.FC<AuthModalProps> = ({ isOpen, onClose }) => {
  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'SIGNED_IN' || event === 'USER_UPDATED') {
        onClose();
      }
    });

    return () => subscription.unsubscribe();
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="relative w-full max-w-md bg-background-secondary p-6 rounded-lg">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-content-secondary hover:text-content-primary"
        >
          <X className="w-5 h-5" />
        </button>

        <Auth
          supabaseClient={supabase}
          appearance={{
            theme: ThemeSupa,
            variables: {
              default: {
                colors: {
                  brand: '#3ECF8E',
                  brandAccent: '#2EA97D',
                  inputText: '#FFFFFF',
                  inputBackground: '#1C1C1C',
                  inputBorder: '#3F3F3F',
                  inputBorderHover: '#3ECF8E',
                  inputBorderFocus: '#3ECF8E',
                  inputPlaceholder: '#ABABAB'
                }
              }
            },
            className: {
              input: 'text-content-primary bg-background border-gray-800',
              label: 'text-content-primary',
              message: 'text-content-secondary'
            }
          }}
          providers={['google']}
          redirectTo={`${window.location.origin}/auth/callback`}
          onlyThirdPartyProviders={false}
          view={window.location.hash === '#auth-reset-password' ? 'update_password' : undefined}
        />
      </div>
    </div>
  );
};

export default AuthModal;